class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector("button");
    const content = button.nextElementSibling;

    button.addEventListener("click", () => {
      const ariaExpanded = button.getAttribute("aria-expanded");
      if (ariaExpanded === "true") {
        button.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-hidden", "true");
      } else {
        button.setAttribute("aria-expanded", "true");
        content.setAttribute("aria-hidden", "false");
      }
    });
  }
}

customElements.define("collapsible-content", CollapsibleContent);
